import React, { useState } from 'react';
import StatisticsTab from '@/components/statistics/StatisticsTab';
import ManagementStateTab from '@/components/statistics/ManagementStateTab';
import PermissionGuard from '@/components/permissions/PermissionGuard';
import { PERMISSIONS } from '@/types/permissions';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const StatisticsPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<'statistics' | 'management'>('statistics');

  return (
    <PermissionGuard 
      permission={PERMISSIONS.STATISTICS_VIEW}
      fallback={
        <div className="min-h-screen bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="text-center py-16">
              <ExclamationTriangleIcon className="h-16 w-16 text-yellow-500 mx-auto mb-4" />
              <h1 className="text-2xl font-bold text-gray-900 mb-2">Accès refusé</h1>
              <p className="text-gray-600">
                Vous n'avez pas les permissions nécessaires pour accéder aux statistiques et rapports.
              </p>
            </div>
          </div>
        </div>
      }
    >
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          {/* Header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">Statistiques et Rapports</h1>
            <p className="mt-2 text-gray-600">
              Analysez les données de pesée et générez des rapports personnalisés
            </p>
          </div>

          {/* Navigation des onglets */}
          <div className="mb-8">
            <div className="border-b border-gray-200">
              <nav className="-mb-px flex space-x-8">
                <button
                  onClick={() => setActiveTab('statistics')}
                  className={`py-2 px-1 border-b-2 font-medium text-sm ${
                    activeTab === 'statistics'
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <i className="fas fa-chart-bar mr-2"></i>
                  Statistiques
                </button>
                <button
                  onClick={() => setActiveTab('management')}
                  className={`py-2 px-1 border-b-2 font-medium text-sm ${
                    activeTab === 'management'
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  <i className="fas fa-clipboard-list mr-2"></i>
                  État de Gestion
                </button>
              </nav>
            </div>
          </div>

          {/* Contenu des onglets */}
          <div className="bg-white rounded-lg shadow">
            {activeTab === 'statistics' && <StatisticsTab />}
            {activeTab === 'management' && <ManagementStateTab />}
          </div>
        </div>
      </div>
    </PermissionGuard>
  );
};

export default StatisticsPage;